// src/Admin/emailTemplates.js
/* =========================================================
   Ready messages for the Send Emails page.
   Plain text only — the design (logo, colors, button, footer) is added by
   emailDesign.js. Words in [brackets] must be filled in before sending.
   Tags: {{firstName}} {{studentName}} {{lastClassDate}} {{centerName}}
   ========================================================= */

const emailTemplates = {
  'demo-followup': {
    name: 'After the free class',
    hint: 'For parents whose child attended the free class',
    for: ['demo-done'],
    subject: 'How did {{firstName}} enjoy the free class?',
    preheader: 'Here is how {{firstName}} can keep learning with RoboMind.',
    heading: 'Thank you for trying RoboMind',
    message: `Dear parent,

Thank you for letting {{firstName}} try a free class with us. We hope it was fun, and that {{firstName}} left a little more curious about coding.

Our classes are online and 1-to-1, so the teacher follows {{firstName}}'s pace and interests. Along the way, children build:
- problem-solving and logical thinking
- creativity, through their own games and projects
- confidence with technology

If you'd like {{firstName}} to continue, reply to this email or message us on WhatsApp. We'll suggest the right course and a schedule that suits you.`,
    buttonType: 'whatsapp',
    buttonLabel: 'Continue on WhatsApp',
  },

  'demo-missed': {
    name: 'Missed the free class',
    hint: 'For parents who booked but did not attend',
    for: ['demo-missed'],
    subject: "Let's find a new time for {{firstName}}'s free class",
    preheader: 'The free class is still waiting for {{firstName}}.',
    heading: 'We missed {{firstName}}!',
    message: `Dear parent,

We noticed {{firstName}} couldn't make it to the free class. No problem at all, it happens.

The free class is still available. Choose a new time that suits you, and we'll take care of the rest.`,
    buttonType: 'freetrial',
    buttonLabel: 'Choose a new time',
  },

  'come-back': {
    name: 'Come back',
    hint: 'For former students (no class in 2+ months)',
    for: ['former'],
    subject: 'We miss {{firstName}} at RoboMind',
    preheader: '{{firstName}} can pick up right where they left off.',
    heading: 'Ready to continue?',
    message: `Dear parent,

It's been a while since {{firstName}}'s last class, and we'd love to see {{firstName}} back.

{{firstName}} can continue from where they stopped, or start a new course. The teacher will prepare a plan based on what {{firstName}} has already learned.

Reply to this email or message us on WhatsApp, and we'll find a schedule that works for you.`,
    buttonType: 'whatsapp',
    buttonLabel: 'Book a class',
  },

  'new-course': {
    name: 'New course',
    hint: 'Announce a new course',
    for: ['active', 'former', 'demo-done'],
    subject: 'New at RoboMind: [course name]',
    preheader: 'A new course for [ages], starting [month].',
    heading: '[Course name] is here',
    message: `Dear parent,

We're happy to share our new course: **[course name]**, for ages [ages].

In this course, children will:
- [what they will learn 1]
- [what they will learn 2]
- [what they will learn 3]

If you'd like {{firstName}} to join, reply to this email or message us on WhatsApp.`,
    buttonType: 'whatsapp',
    buttonLabel: 'Ask about the course',
  },

  offer: {
    name: 'Special offer',
    hint: 'A discount or limited offer',
    for: ['demo-done', 'former', 'active'],
    subject: 'A special offer for {{firstName}}, until [date]',
    preheader: '[Short description of the offer].',
    heading: 'A special offer for {{firstName}}',
    message: `Dear parent,

[Describe the offer in one or two sentences.]

The offer is valid until **[date]**.

Reply to this email or message us on WhatsApp to book.`,
    buttonType: 'whatsapp',
    buttonLabel: 'Get the offer',
  },

  update: {
    name: 'Important update',
    hint: 'Holidays, schedule changes, news',
    for: ['active'],
    subject: '[Short title of the update]',
    preheader: '[One line about the update].',
    heading: '[Title of the update]',
    message: `Dear parent,

[Write the update here.]

If you have any question, just reply to this email.`,
    buttonType: 'none',
    buttonLabel: '',
  },

  event: {
    name: 'Event invitation',
    hint: 'Workshops, open days, camps',
    for: ['active', 'former', 'demo-done'],
    subject: "You're invited: [event name]",
    preheader: '[Date] · [Place]',
    heading: "You're invited: [event name]",
    message: `Dear parent,

We'd love to see {{firstName}} at **[event name]**.

- Date: [date and time]
- Place: [place]
- Age: [ages]

[One or two sentences about what children will do.]

Places are limited. Reply to this email or message us on WhatsApp to book a place.`,
    buttonType: 'whatsapp',
    buttonLabel: 'Book a place',
  },

  'center-collaboration': {
    name: 'Center partnership',
    hint: 'For schools and centers',
    for: ['centers'],
    subject: 'Coding & robotics workshops at {{centerName}}',
    preheader: 'Workshops, after-school clubs and holiday camps, run by our teachers.',
    heading: "Let's bring coding to {{centerName}}",
    message: `Hello {{centerName}} team,

RoboMind Academy teaches coding, robotics and AI to children and teens. We'd love to explore a partnership with {{centerName}}: workshops, after-school clubs or holiday camps, run by our teachers at your center.

We can adapt the topics and ages to your students.

Would you be open to a short call this week?`,
    buttonType: 'whatsapp',
    buttonLabel: 'Talk to us',
  },

  blank: {
    name: 'Start from scratch',
    hint: 'An empty email',
    for: [],
    subject: '',
    preheader: '',
    heading: '',
    message: 'Dear parent,\n\n',
    buttonType: 'whatsapp',
    buttonLabel: 'Message us on WhatsApp',
  },
};

export default emailTemplates;
